<template>
    <!-- 团队筛选 + 搜索过滤 -->
    <div class="ssh-toolbar no-select">
        <div v-if="isLogin" class="ssh-toolbar__filter">
            <el-select v-model="teamId" class="ssh-team-select" placeholder="全部团队" clearable>
                <el-option v-for="team in visibleTeamList" :key="team.id"
                    :label="`${team.name} 【${teamMatchCounts[team.id] || 0}】`" :value="team.id" />
            </el-select>
        </div>
        <div class="ssh-toolbar__search">
            <el-input v-model="keyword" class="ssh-search" placeholder="搜索服务器或命令" clearable>
                <template #prefix>
                    <el-icon>
                        <Search />
                    </el-icon>
                </template>
            </el-input>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SshToolbar',
    props: {
        isLogin: { type: Boolean, default: false },
        visibleTeamList: { type: Array, default: () => [] },
        teamMatchCounts: { type: Object, default: () => ({}) },
        selectedTeamId: { type: [String, Number], default: '' },
        searchKeyword: { type: String, default: '' }
    },
    emits: ['update:selectedTeamId', 'update:searchKeyword'],
    computed: {
        // 选中团队：回写父组件的 selectedTeamId
        teamId: {
            get() {
                return this.selectedTeamId;
            },
            set(value) {
                this.$emit('update:selectedTeamId', value);
            }
        },
        // 搜索关键字：回写父组件的 searchKeyword
        keyword: {
            get() {
                return this.searchKeyword;
            },
            set(value) {
                this.$emit('update:searchKeyword', value);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.ssh-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;
}

.ssh-toolbar__filter {
    flex: 0 0 auto;
}

.ssh-team-select {
    width: 240px;
}

.ssh-team-select :deep(.el-select__wrapper) {
    border-radius: 10px;
    background-color: #ffffff;
    box-shadow: 0 0 0 1px var(--ssh-line) inset;
    transition: box-shadow 0.2s;
}

.ssh-team-select :deep(.el-select__wrapper:hover) {
    box-shadow: 0 0 0 1px #cfd8e6 inset;
}

.ssh-team-select :deep(.el-select__wrapper.is-focused) {
    box-shadow: 0 0 0 1px var(--el-color-primary) inset;
}

.ssh-toolbar__search {
    /* 未登录时工具条内只剩搜索框，margin-left: auto 保证它仍然靠右 */
    flex: 0 1 300px;
    min-width: 200px;
    margin-left: auto;
}

.ssh-search :deep(.el-input__wrapper) {
    border-radius: 10px;
    background-color: #ffffff;
    box-shadow: 0 0 0 1px var(--ssh-line) inset;
    transition: box-shadow 0.2s;
}

.ssh-search :deep(.el-input__wrapper:hover) {
    box-shadow: 0 0 0 1px #cfd8e6 inset;
}

.ssh-search :deep(.el-input__wrapper.is-focus) {
    box-shadow: 0 0 0 1px var(--el-color-primary) inset;
}

/* ---------- 移动端适配 ---------- */
@media (max-width: 768px) {
    .ssh-toolbar {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
    }

    .ssh-toolbar__filter,
    .ssh-toolbar__search {
        flex: 1 1 auto;
        width: 100%;
        min-width: 0;
        margin-left: 0;
    }

    .ssh-team-select {
        width: 100%;
    }
}
</style>
